import { styled, Grid2, Typography, Box } from "@mui/material";
import { TEXT_SHADOW } from "./utils";

export const MainContainer = styled(Grid2)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexGrow: 1,
  height: "100%",
  zIndex: 2,
  opacity: 1,
  backgroundImage: theme.palette.mode === "dark" ? "url('/domotica.jpg')" : "url('/domotica_light.jpg')",
  backgroundPositionX: "50%",
  backgroundPositionY: "50%",
  backgroundSize: "70%",
  backgroundColor: "#000",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  transition: "filter 0.3s ease-in-out",
}));

export const CenterContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));



export const UnderlineTitle2 = styled(Typography)(({ theme }) => ({
  textTransform: "uppercase",
  textAlign: "left",
  position: "relative",
  fontSize: 20,
  color: theme.palette.secondary.main,
  WebkitFontSmoothing: "antialiased",
  textShadow: TEXT_SHADOW,
  "&::after": {
    content: '""',
    position: "absolute",
    height: "2px",
    width: "80%",
    boxShadow: TEXT_SHADOW,
    left: "10%",
    backgroundColor:theme.palette.secondary.main,
    bottom: "-5px",
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  textTransform: "uppercase",
  textAlign: "center",
  position: "relative",
  color: theme.palette.secondary.main,
  letterSpacing: "2px",
  WebkitFontSmoothing: "antialiased",
}));
